import { render } from "./SpacerBlock.vue?vue&type=template&id=53fc14a4&scoped=true"
import script from "./SpacerBlock.vue?vue&type=script&lang=js"
export * from "./SpacerBlock.vue?vue&type=script&lang=js"

import "./SpacerBlock.vue?vue&type=style&index=0&id=53fc14a4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53fc14a4"]])

export default __exports__